/**
 * @flow
 * @relayHash e1ee7f158508bd40d896a7ddf8780c50
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type InvoiceStatus = "DRAFT" | "OVERDUE" | "PAID" | "PARTIALLY_PAID" | "SENT" | "VOID";
export type AddInvoiceInput = {|
  orderId?: ?string,
  customerId: string,
  currency?: ?string,
  discountPercent?: ?number,
  taxRate?: ?number,
  billingAddressLine1?: ?string,
  billingAddressLine2?: ?string,
  billingAddressCity?: ?string,
  billingAddressState?: ?string,
  billingAddressZip?: ?string,
  issueDate?: ?any,
  dueDate?: ?any,
  notes?: ?string,
  terms?: ?string,
  partialPercent?: ?number,
  milestoneLabel?: ?string,
  lineItems?: ?$ReadOnlyArray<InvoiceLineInput>,
|};
export type InvoiceLineInput = {|
  itemId?: ?string,
  description?: ?string,
  quantity: number,
  unitPrice: number,
  discountPercent?: ?number,
|};
export type AddInvoiceMutationVariables = {|
  input: AddInvoiceInput
|};
export type AddInvoiceMutationResponse = {|
  +addInvoice: {|
    +invoiceEdge: {|
      +node: {|
        +id: string,
        +invoiceNumber: string,
        +status: InvoiceStatus,
        +currency: string,
        +subtotal: number,
        +discountPercent: number,
        +discountAmount: number,
        +taxRate: number,
        +taxAmount: number,
        +totalAmount: number,
        +amountPaid: number,
        +amountDue: number,
        +partialPercent: number,
        +milestoneLabel: ?string,
        +issueDate: ?any,
        +dueDate: ?any,
        +notes: ?string,
        +terms: ?string,
        +order: ?{|
          +id: string,
          +orderNumber: string,
        |},
        +customer: {|
          +id: string,
          +name: string,
        |},
        +updatedAt: any,
        +createdAt: any,
      |}
    |}
  |}
|};
export type AddInvoiceMutation = {|
  variables: AddInvoiceMutationVariables,
  response: AddInvoiceMutationResponse,
|};
*/


/*
mutation AddInvoiceMutation(
  $input: AddInvoiceInput!
) {
  addInvoice(input: $input) {
    invoiceEdge {
      node {
        id
        invoiceNumber
        status
        currency
        subtotal
        discountPercent
        discountAmount
        taxRate
        taxAmount
        totalAmount
        amountPaid
        amountDue
        partialPercent
        milestoneLabel
        issueDate
        dueDate
        notes
        terms
        order {
          id
          orderNumber
        }
        customer {
          id
          name
        }
        updatedAt
        createdAt
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddInvoiceInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "addInvoice",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddInvoicePayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "invoiceEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "InvoiceEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Invoice",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "invoiceNumber",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "status",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "currency",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "subtotal",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "discountPercent",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "discountAmount",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "taxRate",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "taxAmount",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "totalAmount",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "amountPaid",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "amountDue",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "partialPercent",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "milestoneLabel",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "issueDate",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "dueDate",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "notes",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "terms",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "order",
                "storageKey": null,
                "args": null,
                "concreteType": "Order",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "orderNumber",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "customer",
                "storageKey": null,
                "args": null,
                "concreteType": "Customer",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "updatedAt",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "createdAt",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "AddInvoiceMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "AddInvoiceMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "AddInvoiceMutation",
    "id": null,
    "text": "mutation AddInvoiceMutation(\n  $input: AddInvoiceInput!\n) {\n  addInvoice(input: $input) {\n    invoiceEdge {\n      node {\n        id\n        invoiceNumber\n        status\n        currency\n        subtotal\n        discountPercent\n        discountAmount\n        taxRate\n        taxAmount\n        totalAmount\n        amountPaid\n        amountDue\n        partialPercent\n        milestoneLabel\n        issueDate\n        dueDate\n        notes\n        terms\n        order {\n          id\n          orderNumber\n        }\n        customer {\n          id\n          name\n        }\n        updatedAt\n        createdAt\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '498ce57848c056a258ccc272061a4eb1';
module.exports = node;
